// Mirrors KFCStKitts/Views/Components/ChefHeader.swift:
// centered title, circular logo with orange stroke on the left, optional
// trailing content on the right, compact padding, subtle bottom shadow.
export default function ChefHeader({ title, right = null, onLogoTap = null }) {
  return (
    <header className="sticky top-0 z-40 bg-white">
      <div className="relative flex items-center justify-between px-3 py-2 max-w-lg mx-auto">
        <button
          type="button"
          onClick={onLogoTap || undefined}
          className="flex items-center gap-2 shrink-0"
        >
          <img
            src="/ChefLogo.jpg"
            alt="CheF SKN"
            className="w-9 h-9 rounded-full object-cover ring-2 ring-[#FF6B35]"
          />
          <span className="text-sm font-extrabold text-gray-900 tracking-tight hidden min-[380px]:inline">
            CheF SKN
          </span>
        </button>
        <h1 className="absolute left-1/2 -translate-x-1/2 text-base font-semibold text-gray-900 truncate max-w-[45%]">
          {title}
        </h1>
        <div className="flex items-center gap-2 shrink-0 min-w-[36px] justify-end">
          {right}
        </div>
      </div>
    </header>
  );
}
